import { Feed, Flag, Send } from "@mui/icons-material";
import { Alert, Card, CardContent, CardHeader, CircularProgress, Typography } from "@mui/material";
import { useRef, useState } from "react";
import DownloadPDFButtons from "../general/DownloadPDFButtons";
import LoadingSkeleton from "../general/LoadingSkeleton";
import PDFCommon from "../PDF/PDFCommon";

function DetailDownload({ dataSantriLengkap }) {
    const buktiPendaftaranRef = useRef();
    const suratInformasiRef = useRef();
    const suratKesanggupanRef = useRef();
    
    // ✅ Track loading state for each PDF
    const [pdfLoadingStates, setPdfLoadingStates] = useState({
        buktiPendaftaran: true,
        suratInformasi: true,
        suratKesanggupan: true
    });

    // ✅ Check if all PDFs are loaded
    const allPdfsLoaded = !Object.values(pdfLoadingStates).some(state => state === true);

    // ✅ Callback when PDF is loaded
    const handlePdfLoaded = (pdfName, success) => {
        console.log(`📄 ${pdfName} loaded:`, success);
        setPdfLoadingStates(prev => ({
            ...prev,
            [pdfName]: false
        }));
    };

    if (!dataSantriLengkap) {
        return (
            <Card>
                <CardContent>
                    <LoadingSkeleton size={1}></LoadingSkeleton>
                </CardContent>
            </Card>
        );
    }

    const buttonsConfig = [
        {
            label: 'Bukti Pendaftaran',
            icon: Send,
            ref: buktiPendaftaranRef,
            pdfComponent: PDFCommon,
            fileName: `bukti-pendaftaran-${dataSantriLengkap.no_daftar}.pdf`,
            data: { 
                dataSantri: dataSantriLengkap, 
                templateKey: 'bukti_pendaftaran',
                onLoadComplete: (success) => handlePdfLoaded('buktiPendaftaran', success)
            },
        },
        {
            label: 'Surat Informasi',
            icon: Feed,
            ref: suratInformasiRef,
            pdfComponent: PDFCommon,
            fileName: `surat-informasi-${dataSantriLengkap.no_daftar}.pdf`,
            data: { 
                dataSantri: dataSantriLengkap, 
                templateKey: 'surat_informasi',
                onLoadComplete: (success) => handlePdfLoaded('suratInformasi', success)
            },
        },
        {
            label: 'Surat Kesanggupan',
            icon: Flag,
            ref: suratKesanggupanRef,
            pdfComponent: PDFCommon,
            fileName: `surat-kesanggupan-${dataSantriLengkap.no_daftar}.pdf`,
            data: { 
                dataSantri: dataSantriLengkap, 
                templateKey: 'surat_kesanggupan',
                onLoadComplete: (success) => handlePdfLoaded('suratKesanggupan', success)
            },
        },
    ];

    return (
        <Card>
            <CardHeader title="Download Berkas" sx={{ borderBottom: "1px solid #f4f4f4" }} />
            <CardContent>
                <Typography variant="body2" sx={{ mb: 2 }}>
                    Download berkas-berkas berikut untuk diisi dan di-upload bersamaan dengan berkas yang lain.
                </Typography>
                
                    {/* ✅ Show loading message */}
                    {!allPdfsLoaded && (
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, mt: 1 }}>
                            ⏳ Memuat data PDF... Mohon tunggu sebentar.
                        </Typography>
                    )}

                    {/* ✅ Pass loading state to buttons */}
                    <DownloadPDFButtons
                        buttons={buttonsConfig}
                        disabled={!allPdfsLoaded} // ✅ Disable until loaded
                    />
            </CardContent>
        </Card>
    );
}

export default DetailDownload;